import { useState, useEffect } from "react"
import MapStyles from "./mapStyles.ts"

const GOOGLE_MAPS_KEY = "AIzaSyBMorjTALAcyj5f4gguT9SAcMyTRIo3fTU"

const useGoogleMap = mapRef => {
  if (typeof window !== "object") return {}

  const [map, setMap] = useState(null)
  const gMaps = window?.google?.maps

  const centerCoordinates = {
    gb: { lat: 57.457976, lng: -4.581396 },
    es: { lat: 40.0, lng: -4.0 },
    us: { lat: 39.8, lng: -99.0 },
    it: { lat: 42.0, lng: 12.5 },
  }

  // Get the correct center based on locale, default to UK (Glasgow)
  const locale = process.env.GATSBY_LOCALE?.toLowerCase()
  const center = centerCoordinates[locale] || centerCoordinates.gb

  const createMap = () => {
    if (typeof window === "object") {
      const map = new window.google.maps.Map(mapRef.current, {
        zoom: 6,
        styles: MapStyles,
        center,
        disableDefaultUI: true,
      })
      setMap(map)
    }
  }

  useEffect(() => {
    const googleMapsScript = document.createElement("script")
    googleMapsScript.src = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAPS_KEY}&libraries=places&language=${process.env.GATSBY_LOCALE}`
    window.document.body.appendChild(googleMapsScript)

    googleMapsScript.addEventListener("load", createMap)
  }, [])

  return { map, gMaps }
}

export default useGoogleMap
